import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card.js';
import axios from 'axios';
import { resolveBackendBase } from '../utils/backendBase.js';
const API_URL = `${resolveBackendBase()}/api`;
const ReportPublic = () => {
    const { token } = useParams();
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    useEffect(() => {
        const load = async () => {
            try {
                const res = await axios.get(`${API_URL}/reports/public/${token}`);
                setData(res.data);
            }
            catch (e) {
                setError('رابط غير صحيح أو انتهت صلاحيته');
            }
            finally {
                setLoading(false);
            }
        };
        load();
    }, [token]);
    if (loading)
        return _jsx("div", { className: "min-h-screen flex items-center justify-center", dir: "rtl", children: "\u062C\u0627\u0631\u064A \u0627\u0644\u062A\u062D\u0645\u064A\u0644..." });
    if (error || !data)
        return _jsx("div", { className: "min-h-screen flex items-center justify-center", dir: "rtl", children: error || 'حدث خطأ' });
    return (_jsx("div", { className: "min-h-screen bg-gradient-to-br from-blue-50 via-white to-slate-50", dir: "rtl", children: _jsx("div", { className: "container mx-auto p-6 max-w-3xl", children: _jsxs(Card, { className: "shadow-xl", children: [_jsx(CardHeader, { children: _jsx(CardTitle, { children: "\u062A\u0642\u0631\u064A\u0631 \u062A\u0634\u062E\u064A\u0635" }) }), _jsxs(CardContent, { className: "space-y-3", children: [_jsx("div", { className: "font-bold text-lg", children: data.title }), _jsx("div", { className: "text-slate-700 whitespace-pre-wrap", children: data.summary }), _jsx("div", { className: "border-t pt-3", children: (data.items || []).length > 0 ? (_jsx("ul", { className: "list-disc pr-6", children: data.items.map((it, idx) => (_jsxs("li", { children: [it.name, " \u2014 \u0627\u0644\u0643\u0645\u064A\u0629: ", it.qty || it.quantity || 1, " \u2014 \u0627\u0644\u0633\u0639\u0631: ", Number(it.price || 0).toFixed(2), " \u2014 \u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A: ", Number(it.total || 0).toFixed(2)] }, idx))) })) : (_jsx("div", { className: "text-slate-500", children: "\u0644\u0627 \u062A\u0648\u062C\u062F \u0639\u0646\u0627\u0635\u0631 \u0645\u0641\u0635\u0644\u0629" })) }), _jsxs("div", { className: "font-bold text-blue-800", children: ["\u0627\u0644\u0625\u062C\u0645\u0627\u0644\u064A: ", Number(data.total).toFixed(2), " \u0631.\u0633"] })] })] }) }) }));
};
export default ReportPublic;
